module.exports = __webpack_public_path__ + "img/banner.144dbad1.jpg";